const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';

const ALIF = '\u0627';
const ALIF_HAMZA_BELOW = '\u0625';
const NOON = '\u0646';
const SEEN = '\u0633';
const TEH = '\u062A';
const YA = '\u064A';

const HARAKAT_RE = /[\u064B-\u065F\u0670]/g;
const NON_ARABIC_LETTERS_RE = /[^\u0621-\u064A]/g;

export const CSV_MASDAR_BINYANIM = new Set(['1', '3']);
export const GENERATED_MASDAR_BINYANIM = new Set(['2', '4', '5', '6', '7', '8', '10']);

const normalizeBinyan = (value) => {
  const match = String(value || '').match(/\d+/);
  return match ? match[0] : String(value || '').trim();
};

const stripHarakat = (value) => (value || '').replace(HARAKAT_RE, '');

const extractRootLetters = (rowOrRoot) => {
  const rootValue = typeof rowOrRoot === 'string'
    ? rowOrRoot
    : rowOrRoot?.root || rowOrRoot?.['שורש'] || '';

  const letters = stripHarakat(rootValue).replace(NON_ARABIC_LETTERS_RE, '');
  return letters.length === 3 ? [letters[0], letters[1], letters[2]] : null;
};

const isFormIILamWeak = (gizraValue) => {
  const gizra = String(gizraValue || '').replace(/\s+/g, '');
  return gizra.includes('ל"ו') || gizra.includes('ל"י');
};

const GENERATED_MASDAR_RULES = {
  '2': {
    pattern: 'تَفْعِيل',
    isSupported: (row) => !isFormIILamWeak(row?.gizra),
    build: ([r1, r2, r3]) => `${TEH}${FATHA}${r1}${SUKUN}${r2}${KASRA}${YA}${r3}`,
  },
  '4': {
    pattern: 'إِفْعَال',
    build: ([r1, r2, r3]) => `${ALIF_HAMZA_BELOW}${KASRA}${r1}${SUKUN}${r2}${FATHA}${ALIF}${r3}`,
  },
  '5': {
    pattern: 'تَفَعُّل',
    build: ([r1, r2, r3]) => `${TEH}${FATHA}${r1}${FATHA}${r2}${SHADDA}${DAMMA}${r3}`,
  },
  '6': {
    pattern: 'تَفَاعُل',
    build: ([r1, r2, r3]) => `${TEH}${FATHA}${r1}${FATHA}${ALIF}${r2}${DAMMA}${r3}`,
  },
  '7': {
    pattern: 'إِنْفِعَال',
    build: ([r1, r2, r3]) => `${ALIF_HAMZA_BELOW}${KASRA}${NOON}${SUKUN}${r1}${KASRA}${r2}${FATHA}${ALIF}${r3}`,
  },
  '8': {
    pattern: 'إِفْتِعَال',
    build: ([r1, r2, r3]) => `${ALIF_HAMZA_BELOW}${KASRA}${r1}${SUKUN}${TEH}${KASRA}${r2}${FATHA}${ALIF}${r3}`,
  },
  '10': {
    pattern: 'إِسْتِفْعَال',
    build: ([r1, r2, r3]) => `${ALIF_HAMZA_BELOW}${KASRA}${SEEN}${SUKUN}${TEH}${KASRA}${r1}${SUKUN}${r2}${FATHA}${ALIF}${r3}`,
  },
};

export const getGeneratedMasdarRule = (binyanValue) => {
  const binyan = normalizeBinyan(binyanValue);
  return GENERATED_MASDAR_RULES[binyan] || null;
};

export const getGeneratedMasdarPattern = (binyanValue) => {
  const rule = getGeneratedMasdarRule(binyanValue);
  return rule ? rule.pattern : null;
};

export const canGenerateMasdarFromPattern = (row) => {
  const rule = getGeneratedMasdarRule(row?.binyan || row?.['בניין']);
  if (!rule) return false;
  if (typeof rule.isSupported === 'function' && !rule.isSupported(row)) return false;
  return Boolean(extractRootLetters(row));
};

export const buildGeneratedMasdar = (row) => {
  const rule = getGeneratedMasdarRule(row?.binyan || row?.['בניין']);
  if (!rule) return null;
  if (typeof rule.isSupported === 'function' && !rule.isSupported(row)) return null;

  const rootLetters = extractRootLetters(row);
  if (!rootLetters) return null;

  return rule.build(rootLetters);
};

export const listGeneratedMasdarPatterns = () => (
  Object.entries(GENERATED_MASDAR_RULES).map(([binyan, rule]) => ({
    binyan,
    pattern: rule.pattern,
  }))
);
